import React from "react";

import { Small } from "@fronterahealth/frontera-ui-components";

interface ReleaseNoteItem {
  title: string;
  body: string;
  url: string;
}

const ALL_RELEASE_NOTES: ReleaseNoteItem[] = [
  {
    title: "August 31–September 6 release notes",
    body: "Clear error messages for password-protected PDFs, improved AI report content, a searchable subtype picker, and fixes for learner search and Export crashes.",
    url: "https://49169539.hs-sites.com/support-hub/week-of-august-31-september-6-2026",
  },
  {
    title: "August 24–30 release notes",
    body: 'A new "My Reports" filter and creator column in Clinical Reports, improved AI-generated content across report sections, and clearer upload error messages.',
    url: "https://49169539.hs-sites.com/support-hub/week-of-august-24-30-2026",
  },
  {
    title: "August 15–23 release notes",
    body: "CFQL-2 and BHI assessment support, insurance-matched templates, a duplicate-reassessment warning, a redesigned client creation form, and visible QA suggestion counts on targets.",
    url: "https://49169539.hs-sites.com/support-hub/-",
  },
  {
    title: "August 10–14 release notes",
    body: "Reassessment progress charts and clinician edits now survive data re-imports, automatic chart refresh after EHR refresh, reliable assessment uploads, and sturdier exports.",
    url: "https://49169539.hs-sites.com/support-hub/week-of-august-10-14-2026",
  },
  {
    title: "August 3–9 release notes",
    body: "BDI-3 assessment support, side-by-side score comparison tables, a redesigned client profile Overview tab, calendar-based dates, and a regenerate option for stuck reports.",
    url: "https://49169539.hs-sites.com/support-hub/week-of-august-3-9-2026",
  },
  {
    title: "July 27–August 2 release notes",
    body: "Automatic KBIT-2 score report processing with a dedicated results layout, three new insurance payors (Evernorth, Molina, and EMI Health), faster recommendation bank loading, and a fix for interview transcripts routing to the wrong report fields.",
    url: "https://49169539.hs-sites.com/support-hub/whats-new-week-of-july-27-august-2-2026",
  },
  {
    title: "July 18–26 release notes",
    body: "A new User Management page for admins, signature settings for clinicians, a dedicated Release Notes page with a refreshed What's New panel, and a new review layout for EarliPoint assessments.",
    url: "https://49169539.hs-sites.com/support-hub/week-of-july-18-26-2026",
  },
  {
    title: "July 13–17 release notes",
    body: "EarliPoint eye-tracking data in reports, faster suggestion review with auto-advance, refined SRS-2 clinical language, and fixes for stuck reports and assessment misclassification.",
    url: "https://49169539.hs-sites.com/support-hub/week-of-july-13",
  },
  {
    title: "July 6–10 release notes",
    body: "QA comment resolution required before finalizing reports, a searchable learner picker in Report Builder, goal customization now available to all users, and export fixes for special characters.",
    url: "https://49169539.hs-sites.com/support-hub/july-6",
  },
  {
    title: "June 29 release notes",
    body: "New assessment types with multi-session scoring, goal bank archiving and preview before import, assessment BCBAs can now approve goals, and improvements to report generation, data syncs, and client roster sync.",
    url: "https://49169539.hs-sites.com/support-hub/week-of-june-",
  },
  {
    title: "June 19–26 release notes",
    body: "Search for more care types and insurance options, clearer goal progress charts, report builder fields can now be cleared, and better-formatted Word document exports.",
    url: "https://49169539.hs-sites.com/support-hub/june-19-26-2026",
  },
  {
    title: "June 8–12 release notes",
    body: "Live event reminders, faster QA reviews, and a round of reliability and export fixes across the platform.",
    url: "https://49169539.hs-sites.com/support-hub/jun-8-12",
  },
  {
    title: "June 1–5 release notes",
    body: "Assessment images now render in reports, plus drag-to-reorder domains, a new QA Packages admin page, and integration reliability improvements.",
    url: "https://49169539.hs-sites.com/support-hub/jun-1-5",
  },
  {
    title: "May 15–21 release notes",
    body: "Reassessments now route to a read-only review step, caregivers can send image and audio attachments, and AI notes pull in context from prior sections.",
    url: "https://49169539.hs-sites.com/support-hub/may-15-21",
  },
  {
    title: "May 10–15 release notes",
    body: "EHR connections are more resilient, progress note edits now stick after approval, and CARS-2 severity is computed automatically.",
    url: "https://49169539.hs-sites.com/support-hub/may-10-15",
  },
];

export const ReleaseNotesPage: React.FC = () => {
  return (
    <div className="flex flex-col w-full items-center my-4 md:my-8">
      <div className="w-full max-w-2xl px-4 sm:px-6">
        <div className="mb-6">
          <h1 className="text-xl font-semibold text-text-primary">Release Notes</h1>
          <p className="mt-1 text-sm text-text-tertiary">A full archive of product updates and improvements.</p>
        </div>
        <div className="rounded-lg border border-border-strong bg-white">
          <ul className="divide-y divide-border-strong">
            {ALL_RELEASE_NOTES.map((item) => (
              <li key={item.url} className="px-6 py-5">
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm font-medium text-interactive-primary-default underline"
                >
                  {item.title}
                </a>
                <Small className="mt-0.5 block text-text-tertiary">{item.body}</Small>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
